/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface NumericValueWithUnitDto
 */
export interface NumericValueWithUnitDto {
    /**
     * 
     * @type {number}
     * @memberof NumericValueWithUnitDto
     */
    value?: number;
    /**
     * 
     * @type {string}
     * @memberof NumericValueWithUnitDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumericValueWithUnitDto
     */
    $type?: NumericValueWithUnitDtoTypeEnum;
}


/**
 * @export
 */
export const NumericValueWithUnitDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoNumericValueWithUnitDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericValueWithUnitDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericValueWithUnitDtoTypeEnum = typeof NumericValueWithUnitDtoTypeEnum[keyof typeof NumericValueWithUnitDtoTypeEnum];


/**
 * Check if a given object implements the NumericValueWithUnitDto interface.
 */
export function instanceOfNumericValueWithUnitDto(value?: unknown): value is NumericValueWithUnitDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericValueWithUnitDtoTypeEnum)[0];
}

export function NumericValueWithUnitDtoFromJSON(json: any): NumericValueWithUnitDto {
    return NumericValueWithUnitDtoFromJSONTyped(json, false);
}

export function NumericValueWithUnitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericValueWithUnitDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : json['value'],
        'unitAbbreviation': !exists(json, 'unitAbbreviation') ? undefined : json['unitAbbreviation'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NumericValueWithUnitDtoToJSON(value?: NumericValueWithUnitDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'value': value.value,
        'unitAbbreviation': value.unitAbbreviation,
        '$type': value.$type,
    });
}

